import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SendCodeButton from '../../components/atoms/SendCodeButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import AnyButton from '../../components/atoms/AnyButton';
import { signUp, confirmSignUp } from '../../auth/Auth';
import GroupAddConfirm from './GroupAddConfirm';
import CheckOkButton from '../../components/atoms/CheckOkButton';
import { getOptionCities } from '../../actions/Cities';
import { getZipCode } from '../../actions/Shop';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px',
    height: '4px'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell90: {
    width: '90%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      cities: state.cities.listCities,
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators({ getZipCode, getOptionCities }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('groupName', 'setGroupName', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('city', 'setCity', ''),
  withState('cityError', 'setCityError', ''),
  withState('cityIdError', 'setCityIdError', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('addressError', 'setAddressError', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('fax', 'setFax', ''),
  withState('faxError', 'setFaxError', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('emailError', 'setEmailError', ''),
  withState('password', 'setPassword', ''),
  withState('passwordError', 'setPasswordError', ''),
  withState('confirmPassword', 'setConfirmPassword', ''),
  withState('confirmPasswordError', 'setConfirmPasswordError', ''),
  withState('emailAuthCode', 'setEmailAuthCode', ''),
  withState('emailAuthCodeError', 'setEmailAuthCodeError', ''),
  withState('emailAuthCodeChecked', 'setEmailAuthCodeChecked', false),
  withState('consent', 'setConsent', false),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes, // actions,
    openGroupAddConfirm,
    cancelAction,
    backAction,
    registerAction,
    groupName,
    setGroupName,
    zipCode,
    setZipCode,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    cityId,
    // cityName,
    // setCityName,
    setCityId,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    fax,
    setFax,
    groupType,
    setGroupType,
    groupTypeStr,
    setGroupTypeStr,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    emailAuthCode,
    setEmailAuthCode,
    updateOpenGroupAdd,
    updateOpenGroupAddConfirm,
    groupNameError,
    setGroupNameError,
    zipCodeError,
    setZipCodeError,
    prefecturesError,
    setPrefecturesError,
    cityIdError,
    setCityIdError,
    // cityError,
    // setCityError,
    addressError,
    setAddressError,
    phoneError,
    setPhoneError,
    faxError,
    setFaxError,
    cognitoUserId,
    setCognitoUserId,
    emailError,
    setEmailError,
    passwordError,
    setPasswordError,
    confirmPasswordError,
    setConfirmPasswordError,
    emailAuthCodeError,
    setEmailAuthCodeError,
    emailAuthCodeChecked,
    setEmailAuthCodeChecked,
    consent,
    setConsent
  }) => {
    const addConfirm = {
      groupName,
      zipCode,
      prefectureCode,
      city,
      // cityName,
      address,
      building,
      phone,
      fax,
      groupTypeStr,
      email
    };
    const addParam = {
      groupName,
      zipCode,
      prefectureCode,
      city,
      // cityName,
      cityId,
      address,
      building,
      phone,
      fax,
      groupType,
      cognitoUserId,
      email
    };
    const errors = {
      groupNameError,
      zipCodeError,
      prefecturesError,
      // cityError,
      cityIdError,
      addressError,
      phoneError,
      faxError,
      emailError,
      passwordError,
      confirmPasswordError,
      emailAuthCodeError
    };

    // const getZipCodeData = async zipcode => {
    //   await actions.getZipCode(zipcode).then(data => {
    //     setPrefectureCode(data.payload.prefectureCode);
    //     setCity(data.payload.city);
    //     setAddress(data.payload.address);
    //   });
    // };

    const checkCityName = () => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const validGroup = () => {
      const value = groupName.trim();
      if (value === '') {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupName(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      // getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };
    // const validCity = () => {
    //   const value = city.trim();
    //   if (value === '') {
    //     setCityError('必須項目です。');
    //     return 1;
    //   }
    //   setCityError('');
    //   setCity(value);
    //   return 0;
    // };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress = () => {
      const value = address.trim();
      if (value === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone.trim();
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validFax = () => {
      const value = fax.trim();
      if (value && !/^\d+$/.test(value)) {
        setFaxError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setFaxError('');
      setFax(value);
      return 0;
    };
    const validEmail = () => {
      const value = email.trim();
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validPassword = () => {
      const value = password.trim();
      if (value === '') {
        setPasswordError('必須項目です。');
        return 1;
      }
      if (
        value.length < 8 ||
        !/[A-Z]/.test(value) ||
        !/[a-z]/.test(value) ||
        !/[0-9]/.test(value)
      ) {
        setPasswordError(
          '英大文字・英小文字・数字全てを含め、8文字以上で入力してください。'
        );
        return 1;
      }
      setPasswordError('');
      setPassword(value);
      return 0;
    };
    const validConfirmPassword = () => {
      const value = password.trim();
      const valueConfirm = confirmPassword.trim();
      if (valueConfirm === '') {
        setConfirmPasswordError('必須項目です。');
        return 1;
      }
      if (value !== valueConfirm) {
        setConfirmPasswordError('パスワードが一致していません。');
        return 1;
      }
      setConfirmPasswordError('');
      setConfirmPassword(value);
      return 0;
    };
    const validEmailAuthCode = () => {
      const value = emailAuthCode.trim();
      if (value === '') {
        setEmailAuthCodeError('必須項目です。');
        return 1;
      }
      setEmailAuthCodeError('');
      setEmailAuthCode(value);
      return 0;
    };
    const valid = () => {
      let errorCount =
        validGroup() +
        validZipCodeSubmit() +
        validPrefectures() +
        validCityId() +
        validAddress() +
        validPhone() +
        validFax();
      if (!emailAuthCodeChecked) {
        errorCount +=
          validEmail() +
          validPassword() +
          validConfirmPassword() +
          validEmailAuthCode();
      }
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const convertGroupTypeStr = mode => {
      if (mode === 'CHAIN_SHOP') {
        setGroupTypeStr('チェーン店');
      } else if (mode === 'COMMERCIAL_COMPLEX') {
        setGroupTypeStr('商業施設');
      } else {
        setGroupTypeStr('その他/仮想店舗');
      }
    };

    const sendCodeAction = () => {
      if (validEmail() + validPassword() + validConfirmPassword() !== 0) {
        alert('メールアドレスとパスワードを正しく入力してください。');
      } else {
        signUp(email, password);
        alert('認証コードを送信しました。メールをご確認ください。');
      }
    };
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else if (emailAuthCodeChecked) {
        updateOpenGroupAddConfirm(true);
      } else {
        confirmSignUp(email, emailAuthCode)
          .then(() => {
            setCityNameData(cityId);
            setEmailAuthCodeChecked(true);
            updateOpenGroupAddConfirm(true);
          })
          .catch(() => {
            alert('認証コードが正しくありません。');
          });
      }
    };
    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };
    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h5">グループ運営会社登録申込書</Typography>
          <Typography className={classes.description}>
            ごちめしアプリをグループとしてご利用いただく方は、以下の申込みフォームにご記入ください。
            <br />
            ご記入にあたっては、こちらの
            <Link
              href="https://drive.google.com/open?id=1Du9YVUrkHdUYGLbHjS2boYdrWSTiOB8w"
              target="_blank"
              rel="noreferrer"
            >
              【ごちめし加盟店規約】
            </Link>
            をご参照、ご同意いただけますようお願いいたします。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCell90}>
                <TextField
                  required
                  label="貴グループ運営会社名"
                  placeholder="〇〇株式会社"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setGroupName(e.target.value);
                  }}
                  onBlur={validGroup}
                />
                <ValidationText message={errors.groupNameError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="郵便番号"
                  className={classes.textField}
                  placeholder="0001111"
                  fullWidth
                  onChange={e => {
                    setZipCode(e.target.value);
                  }}
                  margin="normal"
                  onBlur={validZipCode}
                />
                <ValidationText message={errors.zipCodeError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  select
                  label="都道府県"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  value={prefectureCode}
                  onChange={e => {
                    setPrefectureCode(e.target.value);
                    setCityId(Number(0));
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onBlur={validPrefectures}
                >
                  {prefectures.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <ValidationText message={errors.prefecturesError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                {prefectureCode > 0 && (
                  <ReactSelectMaterialUi
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                {(!prefectureCode || prefectureCode <= 0) && (
                  <ReactSelectMaterialUi
                    disabled
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                <ValidationText message={errors.cityIdError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="丁目・番地"
                  placeholder="1-2-3"
                  fullWidth
                  value={address}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                  onBlur={validAddress}
                />
                <ValidationText message={errors.addressError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  label="建物名"
                  placeholder="○○ビル 102号"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setBuilding(e.target.value);
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="電話番号"
                  placeholder="09012345678"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setPhone(e.target.value);
                  }}
                  onBlur={validPhone}
                />
                <ValidationText message={errors.phoneError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="FAX"
                  placeholder="09012345678"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setFax(e.target.value);
                  }}
                  onBlur={validFax}
                />
                <ValidationText message={errors.faxError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <Typography className={classes.description}>
                  グループ種別
                </Typography>
                <RadioGroup
                  row
                  value={groupType}
                  onChange={e => {
                    setGroupType(e.target.value);
                    convertGroupTypeStr(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="CHAIN_SHOP"
                    control={<Radio color="primary" />}
                    label="チェーン店"
                  />
                  <FormControlLabel
                    value="COMMERCIAL_COMPLEX"
                    control={<Radio color="primary" />}
                    label="商業施設"
                  />
                  <FormControlLabel
                    value="OTHERS"
                    control={<Radio color="primary" />}
                    label="その他/仮想店舗"
                  />
                </RadioGroup>
              </TableCell>
            </TableRow>
          </Table>

          <Divider className={classes.divider} />
          <div className={classes.subTitle}>
            <Typography variant="h6">メールアドレス確認</Typography>
            <Typography className={classes.description}>
              メールアドレスとパスワードを入力して、
              メールアドレス宛に届いた認証コードを入力してください。
            </Typography>
          </div>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell
                className={classNames(
                  classes.tableCellBorderNone,
                  classes.tableCell90
                )}
              >
                <TextField
                  required
                  label="メールアドレス"
                  placeholder="gochimeshi@gochi.com"
                  type="email"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                  onBlur={validEmail}
                />
                <ValidationText message={errors.emailError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="パスワード"
                  type="password"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setPassword(e.target.value);
                  }}
                  onBlur={validPassword}
                />
                <ValidationText message={errors.passwordError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                英大文字・英小文字・数字全てを含め、8文字以上
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="確認用パスワード"
                  type="password"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setConfirmPassword(e.target.value);
                  }}
                  onBlur={validConfirmPassword}
                />
                <ValidationText message={errors.confirmPasswordError} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <SendCodeButton
                  onClickAction={sendCodeAction}
                  enabled={!emailAuthCodeChecked}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
                {emailAuthCodeChecked && <CheckOkButton />}
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="認証コード"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: emailAuthCodeChecked
                  }}
                  onChange={e => {
                    setEmailAuthCode(e.target.value);
                  }}
                  onBlur={validEmailAuthCode}
                />
                <ValidationText message={errors.emailAuthCodeError} />
              </TableCell>
            </TableRow>
          </Table>
          <Divider className={classes.divider} />
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={consent}
                      onChange={e => {
                        setConsent(e.target.checked);
                      }}
                      color="primary"
                    />
                  }
                  label="ごちめし加盟店規約に同意する"
                />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} consent={consent} />
        </div>
        <Modal open={openGroupAddConfirm}>
          <GroupAddConfirm
            updateOpenGroupAdd={updateOpenGroupAdd}
            updateOpenGroupAddConfirm={updateOpenGroupAddConfirm}
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={addConfirm}
            addParam={addParam}
            email={email}
            password={password}
            prefectures={prefectures}
            setCognitoUserId={setCognitoUserId}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
